import React from 'react'
import SEO from '../../seo/SEO' 
import First_AboutUs_Section from './First_AboutUs_Section/First_AboutUs_Section'
import Second_AboutUs_Section from './Second_AboutUs_Section/Second_AboutUs_Section'
import Third_AboutUs_Section from './Third_AboutUs_Section/Third_AboutUs_Section'
import Fifth_Aboutus_Section from './Fifth_Aboutus_Section/Fifth_Aboutus_Section'
import Sixth_Aboutus_Section from './Sixth_Aboutus_Section/Sixth_Aboutus_Section'
import Seventh_About_Section from './Seventh_About_Section/Seventh_About_Section'
import { AboutUsBanner } from './AboutUsBanner/AboutUsBanner'

const AboutUsMain = () => {
  return (

    <>
      <SEO />
    <div>
     <AboutUsBanner/>
        <First_AboutUs_Section/>
        <Second_AboutUs_Section/>
        <Third_AboutUs_Section/>
        <Fifth_Aboutus_Section/>
        <Sixth_Aboutus_Section/>
        <Seventh_About_Section/>
    </div>
    </>
  )
}

export default AboutUsMain